<template>
  <div class="tabar">
    <ul>
      <li
        v-for="(item,index) in tabList"
        :key="index"
        @click="switchTo(item.path)"
        :class="{ active: item.path == $route.path }"
      >
        <img :src="item.path == $route.path ? item.icon_active : item.icon " alt  class="z-index:100;"/>
        {{item.title}}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "tabar",
  data(){
    return{
      tabList: [
        {
          title: "首页",
          path: "/",
          icon: require("@/assets/images/home-img/home.png"),
          icon_active: require("@/assets/images/home-img/home-pitch.png")
        },
        {
          title: "我的",
          path: "/my",
          icon: require("@/assets/images/home-img/my.png"),
          icon_active: require("@/assets/images/home-img/my-pitch.png")
        },
      ]
    }
  },
  components:{
  },
  methods:{
    switchTo(path) {
      if(path == this.$route.path){
        this.$router.go(0)
      }
      this.$router.replace(`${path}`);
    }
  }
}
</script>
<style lang="less" scoped>
  .tabar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1rem;
    z-index: 100;
    box-shadow: 0 0 0.15rem 0.01rem #e6e6e6;
    
    // -webkit-box-shadow: 0rem 0rem 0rem .01rem rgba(0,0,0,0.5);
    *{
      border:0;
    }
    ul {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      background: #fff;
      justify-content: space-around;
      // &::after {
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 1px;
      //   background: #999;
      // }
    }
    li {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-size: 12px;
      border:0;
      color: #999999;
      img {
        width: .45rem;
        height: .44rem;
        margin: 5px 0;
      }
      &.active {
        color: #EF8201;
        font-weight: 600;
      }
    }
  }
</style>